export default "__VITE_ASSET__DKQT9kXE__"